(function () {
  /*
    AMMY - Precio tachado automático

    Qué hace:
    - Muestra precio original tachado + precio con descuento.
    - Funciona en página de producto.
    - Funciona en tarjetas de producto: colección, home, productos destacados.
    - Solo toma descuentos AUTOMÁTICOS aplicados a la línea del producto.
    - NO usa códigos de descuento.
    - NO muestra descuentos privados con código.
    - NO cambia el precio real del producto.
    - NO duplica descuentos en carrito.
  */

  var STOREFRONT_TOKEN = '32cf8193b355ccc4fdc3ac058166ebec';
  var API_VERSION = '2026-07';

  var cache = {};
  var initialized = false;

  function getShopDomain() {
    if (window.Shopify && Shopify.shop) {
      return Shopify.shop;
    }

    return window.location.hostname;
  }

  function getEndpoint() {
    return 'https://' + getShopDomain() + '/api/' + API_VERSION + '/graphql.json';
  }

  function toVariantGid(variantId) {
    variantId = String(variantId || '').trim();

    if (!variantId) return null;

    if (variantId.indexOf('gid://shopify/ProductVariant/') === 0) {
      return variantId;
    }

    return 'gid://shopify/ProductVariant/' + variantId;
  }

  function formatMoney(amount, currencyCode) {
    var number = Number(amount);

    if (!Number.isFinite(number)) {
      number = 0;
    }

    try {
      return new Intl.NumberFormat('es-MX', {
        style: 'currency',
        currency: currencyCode || 'MXN',
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      }).format(number);
    } catch (error) {
      return '$' + number.toFixed(2) + ' ' + (currencyCode || 'MXN');
    }
  }

  function injectStyles() {
    if (document.getElementById('ammy-auto-product-discounts-style')) return;

    var style = document.createElement('style');
    style.id = 'ammy-auto-product-discounts-style';
    style.textContent = [
      '.ammy-native-price-hidden { display: none !important; }',

      '.ammy-auto-price {',
      '  display: flex;',
      '  align-items: baseline;',
      '  gap: 0.8rem;',
      '  flex-wrap: wrap;',
      '  margin: 0.2rem 0 0.6rem;',
      '}',

      '.ammy-auto-price__regular {',
      '  text-decoration: line-through;',
      '  opacity: 0.55;',
      '  font-size: 1.6rem;',
      '}',

      '.ammy-auto-price__sale {',
      '  font-weight: 700;',
      '  font-size: 2rem;',
      '  color: rgb(var(--color-foreground));',
      '}',

      '.ammy-auto-price__badge {',
      '  font-size: 1.1rem;',
      '  line-height: 1;',
      '  letter-spacing: 0.06em;',
      '  text-transform: uppercase;',
      '  border: 1px solid rgba(var(--color-foreground), 0.35);',
      '  border-radius: 999px;',
      '  padding: 0.45rem 0.7rem;',
      '}',

      '.ammy-auto-price__note {',
      '  width: 100%;',
      '  font-size: 1.2rem;',
      '  opacity: 0.75;',
      '  margin-top: -0.2rem;',
      '}',

      '.ammy-auto-price--card {',
      '  gap: 0.45rem;',
      '  margin: 0.2rem 0 0.4rem;',
      '}',

      '.ammy-auto-price--card .ammy-auto-price__regular {',
      '  font-size: 1.25rem;',
      '}',

      '.ammy-auto-price--card .ammy-auto-price__sale {',
      '  font-size: 1.45rem;',
      '}',

      '.ammy-auto-price--card .ammy-auto-price__badge {',
      '  font-size: 0.95rem;',
      '  padding: 0.35rem 0.55rem;',
      '}',

      '.ammy-auto-price--card .ammy-auto-price__note {',
      '  display: none;',
      '}'
    ].join('\n');

    document.head.appendChild(style);
  }

  function removeCustomPrice(priceWrapper) {
    if (!priceWrapper) return;

    var customPrice = priceWrapper.querySelector('.ammy-auto-price');
    var nativePrice = priceWrapper.querySelector('.price');

    if (customPrice) {
      customPrice.remove();
    }

    if (nativePrice) {
      nativePrice.classList.remove('ammy-native-price-hidden');
    }
  }

  function renderCustomPrice(priceWrapper, result, mode) {
    if (!priceWrapper || !result) return;

    var nativePrice = priceWrapper.querySelector('.price');

    if (!nativePrice) return;

    var original = Number(result.originalAmount);
    var discounted = Number(result.discountedAmount);
    var currencyCode = result.currencyCode || 'MXN';

    if (!Number.isFinite(original) || !Number.isFinite(discounted)) {
      removeCustomPrice(priceWrapper);
      return;
    }

    if (discounted >= original) {
      removeCustomPrice(priceWrapper);
      return;
    }

    var discountPercent = Math.round(((original - discounted) / original) * 100);

    var oldCustomPrice = priceWrapper.querySelector('.ammy-auto-price');

    if (oldCustomPrice) {
      oldCustomPrice.remove();
    }

    nativePrice.classList.add('ammy-native-price-hidden');

    var customPrice = document.createElement('div');
    customPrice.className = 'ammy-auto-price';

    if (mode === 'card') {
      customPrice.className += ' ammy-auto-price--card';
    }

    customPrice.setAttribute('data-ammy-auto-discount', 'true');

    customPrice.innerHTML =
      '<span class="ammy-auto-price__regular">' + formatMoney(original, currencyCode) + '</span>' +
      '<span class="ammy-auto-price__sale">' + formatMoney(discounted, currencyCode) + '</span>' +
      '<span class="ammy-auto-price__badge">-' + discountPercent + '%</span>' +
      '<span class="ammy-auto-price__note">Descuento automático aplicado al producto.</span>';

    priceWrapper.appendChild(customPrice);
  }

  function hasAutomaticProductLineDiscount(line) {
    if (!line || !Array.isArray(line.discountAllocations)) {
      return false;
    }

    return line.discountAllocations.some(function (allocation) {
      if (!allocation) return false;

      if (allocation.__typename !== 'CartAutomaticDiscountAllocation') {
        return false;
      }

      if (allocation.targetType && allocation.targetType !== 'LINE_ITEM') {
        return false;
      }

      var amount = allocation.discountedAmount && Number(allocation.discountedAmount.amount);

      return Number.isFinite(amount) && amount > 0;
    });
  }

  function getDiscountedLineResult(cart) {
    if (!cart || !cart.lines || !cart.lines.nodes || !cart.lines.nodes.length) {
      return null;
    }

    var line = cart.lines.nodes[0];

    if (!hasAutomaticProductLineDiscount(line)) {
      return null;
    }

    var merchandisePrice = line.merchandise && line.merchandise.price;
    var totalAmount = line.cost && line.cost.totalAmount;

    if (!merchandisePrice || !totalAmount) {
      return null;
    }

    var original = Number(merchandisePrice.amount);
    var discounted = Number(totalAmount.amount);
    var currencyCode = totalAmount.currencyCode || merchandisePrice.currencyCode || 'MXN';

    if (!Number.isFinite(original) || !Number.isFinite(discounted)) {
      return null;
    }

    if (discounted >= original) {
      return null;
    }

    return {
      originalAmount: original,
      discountedAmount: discounted,
      currencyCode: currencyCode
    };
  }

  function fetchAutomaticDiscountForVariant(variantId) {
    var gid = toVariantGid(variantId);

    if (!gid) {
      return Promise.resolve(null);
    }

    if (cache[gid]) {
      return cache[gid];
    }

    var query = `
      mutation AmmyAutomaticProductDiscount($variantId: ID!) {
        cartCreate(input: {
          lines: [
            {
              merchandiseId: $variantId,
              quantity: 1
            }
          ]
        }) {
          cart {
            lines(first: 1) {
              nodes {
                quantity
                merchandise {
                  ... on ProductVariant {
                    id
                    price {
                      amount
                      currencyCode
                    }
                  }
                }
                discountAllocations {
                  __typename
                  targetType
                  discountedAmount {
                    amount
                    currencyCode
                  }
                  ... on CartAutomaticDiscountAllocation {
                    title
                  }
                  ... on CartCodeDiscountAllocation {
                    code
                  }
                }
                cost {
                  totalAmount {
                    amount
                    currencyCode
                  }
                }
              }
            }
          }
          userErrors {
            field
            message
          }
        }
      }
    `;

    cache[gid] = fetch(getEndpoint(), {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Shopify-Storefront-Access-Token': STOREFRONT_TOKEN
      },
      body: JSON.stringify({
        query: query,
        variables: {
          variantId: gid
        }
      })
    })
      .then(function (response) {
        if (!response.ok) {
          throw new Error('Storefront API error: ' + response.status);
        }

        return response.json();
      })
      .then(function (payload) {
        if (payload.errors && payload.errors.length) {
          console.warn('[AMMY descuentos]', payload.errors);
          return null;
        }

        var cartCreate = payload.data && payload.data.cartCreate;

        if (!cartCreate || !cartCreate.cart) {
          return null;
        }

        if (cartCreate.userErrors && cartCreate.userErrors.length) {
          console.warn('[AMMY descuentos]', cartCreate.userErrors);
          return null;
        }

        return getDiscountedLineResult(cartCreate.cart);
      })
      .catch(function (error) {
        console.warn('[AMMY descuentos] No se pudo revisar descuento automático:', error);
        return null;
      });

    return cache[gid];
  }

  function getProductRoots() {
    return Array.prototype.slice.call(document.querySelectorAll('product-info[id^="MainProduct-"]'));
  }

  function getProductVariantInput(root) {
    return root.querySelector('form[action*="/cart/add"] input[name="id"]') ||
      root.querySelector('input[name="id"][form^="product-form"]') ||
      root.querySelector('input[name="id"]');
  }

  function getCurrentProductVariantId(root) {
    var input = getProductVariantInput(root);

    if (!input || !input.value) {
      return null;
    }

    return String(input.value).trim();
  }

  function getProductPriceWrapper(root) {
    return root.querySelector('[id^="price-"]');
  }

  function updateProductRoot(root) {
    if (!root) return;

    var variantId = getCurrentProductVariantId(root);
    var priceWrapper = getProductPriceWrapper(root);

    if (!variantId || !priceWrapper) {
      removeCustomPrice(priceWrapper);
      return;
    }

    root.setAttribute('data-ammy-current-variant', variantId);

    fetchAutomaticDiscountForVariant(variantId).then(function (result) {
      var latestVariantId = getCurrentProductVariantId(root);

      if (String(latestVariantId) !== String(variantId)) {
        return;
      }

      if (result) {
        renderCustomPrice(priceWrapper, result, 'product');
      } else {
        removeCustomPrice(priceWrapper);
      }
    });
  }

  function scheduleProductUpdate(root) {
    if (!root) return;

    window.clearTimeout(root.__ammyDiscountTimer);

    root.__ammyDiscountTimer = window.setTimeout(function () {
      updateProductRoot(root);
    }, 250);
  }

  function initProductRoot(root) {
    if (!root || root.__ammyDiscountInitialized) return;

    root.__ammyDiscountInitialized = true;

    scheduleProductUpdate(root);

    root.addEventListener('change', function () {
      scheduleProductUpdate(root);
      window.setTimeout(function () { scheduleProductUpdate(root); }, 500);
      window.setTimeout(function () { scheduleProductUpdate(root); }, 1000);
    });

    root.addEventListener('click', function () {
      window.setTimeout(function () { scheduleProductUpdate(root); }, 250);
      window.setTimeout(function () { scheduleProductUpdate(root); }, 800);
    });

    var observer = new MutationObserver(function () {
      var currentVariantId = getCurrentProductVariantId(root);
      var savedVariantId = root.getAttribute('data-ammy-current-variant');

      if (currentVariantId && String(currentVariantId) !== String(savedVariantId)) {
        scheduleProductUpdate(root);
      }
    });

    observer.observe(root, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['value', 'selected', 'checked']
    });
  }

  function getCardRoots() {
    return Array.prototype.slice.call(document.querySelectorAll('[data-ammy-discount-card="true"]'));
  }

  function getCardVariantId(card) {
    if (!card) return null;

    var variantId = card.getAttribute('data-ammy-variant-id');

    if (variantId) {
      return String(variantId).trim();
    }

    var input = card.querySelector('input[name="id"]');

    if (input && input.value) {
      return String(input.value).trim();
    }

    return null;
  }

  function getCardPriceWrapper(card) {
    if (!card) return null;

    return card.querySelector('[data-ammy-price-wrapper="true"]') ||
      card.querySelector('.card-information');
  }

  function updateCard(card, index) {
    if (!card) return;

    var variantId = getCardVariantId(card);
    var priceWrapper = getCardPriceWrapper(card);

    if (!variantId || !priceWrapper) {
      removeCustomPrice(priceWrapper);
      return;
    }

    card.setAttribute('data-ammy-current-variant', variantId);

    window.setTimeout(function () {
      fetchAutomaticDiscountForVariant(variantId).then(function (result) {
        var latestVariantId = getCardVariantId(card);

        if (String(latestVariantId) !== String(variantId)) {
          return;
        }

        if (result) {
          renderCustomPrice(priceWrapper, result, 'card');
        } else {
          removeCustomPrice(priceWrapper);
        }
      });
    }, Math.min(index * 120, 1800));
  }

  function initCard(card, index) {
    if (!card || card.__ammyDiscountInitialized) return;

    card.__ammyDiscountInitialized = true;
    updateCard(card, index || 0);
  }

  function initAllCards() {
    getCardRoots().forEach(function (card, index) {
      initCard(card, index);
    });
  }

  function initAllProducts() {
    getProductRoots().forEach(function (root) {
      initProductRoot(root);
    });
  }

  function init() {
    injectStyles();
    initAllProducts();
    initAllCards();

    if (!initialized) {
      initialized = true;

      var bodyObserver = new MutationObserver(function () {
        window.clearTimeout(window.__ammyDiscountBodyTimer);
        window.__ammyDiscountBodyTimer = window.setTimeout(function () {
          initAllProducts();
          initAllCards();
        }, 300);
      });

      bodyObserver.observe(document.body, {
        childList: true,
        subtree: true
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();